import { format } from 'date-fns';
import { ReportColumn } from '../shared/types';
import { formatMoney } from '@/utils/currency';

export interface SupplierSummaryRow {
  supplier: string;
  supplier_name: string;
  number_of_bills: number;
  quantity_purchased: number;
  net_purchase: number;
  paid_amount: number;
  outstanding: number;
  last_purchase_date: string;
  average_bill_value: number;
}

export const supplierSummaryColumns: ReportColumn<SupplierSummaryRow>[] = [
  { id: 'supplier_name', header: 'Supplier', accessorKey: 'supplier_name' },
  { id: 'number_of_bills', header: 'Number of Bills', accessorKey: 'number_of_bills', align: 'right' },
  { id: 'quantity_purchased', header: 'Quantity Purchased', accessorKey: 'quantity_purchased', align: 'right' },
  {
    id: 'net_purchase',
    header: 'Net Purchase',
    align: 'right',
    cell: (r) => `${formatMoney(r.net_purchase)}`,
    exportValue: (r) => r.net_purchase,
  },
  {
    id: 'paid_amount',
    header: 'Paid Amount',
    align: 'right',
    cell: (r) => `${formatMoney(r.paid_amount)}`,
    exportValue: (r) => r.paid_amount,
  },
  {
    id: 'outstanding',
    header: 'Outstanding',
    align: 'right',
    cell: (r) => `${formatMoney(r.outstanding)}`,
    exportValue: (r) => r.outstanding,
  },
  {
    id: 'last_purchase_date',
    header: 'Last Purchase Date',
    cell: (r) => (r.last_purchase_date ? format(new Date(r.last_purchase_date), 'd MMM yyyy') : ''),
    exportValue: (r) => r.last_purchase_date,
  },
  {
    id: 'average_bill_value',
    header: 'Average Bill Value',
    align: 'right',
    cell: (r) => `${formatMoney(r.average_bill_value)}`,
    exportValue: (r) => r.average_bill_value,
  },
];
